import { media, P } from 'ia-react-core';
import styled from 'styled-components';
import ContactInformation from '../ContactInformation';

export const StyledLinePrompt = styled(P)`
  margin-top: 26px;
  font-size: 12px;
  line-height: 1.17;
`;

export const StyledContactInformation = styled(ContactInformation)`
  padding-bottom: 24px;
  padding-right: 16px;
  flex: 1 0 200px;
  min-width: 40%;
  max-width: none;
  section{
    margin-right: 48px;
  }

  ${media.sm`
    display:flex;
    section {
      margin-top: 0px;
      width:50%;
    }
  `};

  &:last-child {
    padding-bottom: 0;
  }
  &:first-child {
    padding-bottom: 0;
  }`;
